import { render, staticRenderFns } from "./quality-assurance-ws-feedback-detail.vue?vue&type=template&id=161f8bcf&scoped=true&"
import script from "./quality-assurance-ws-feedback-detail.vue?vue&type=script&lang=js&"
export * from "./quality-assurance-ws-feedback-detail.vue?vue&type=script&lang=js&"
import style0 from "./quality-assurance-ws-feedback-detail.vue?vue&type=style&index=0&id=161f8bcf&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161f8bcf",
  null
  
)

export default component.exports